class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('lkp-details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.overlay = document.querySelector('.lkp-mega-overlay');

    if (this.overlay && !this.overlay._lkpBound) {
      this.overlay.addEventListener('click', () => {
        document.querySelectorAll('lkp-header-menu details[open]').forEach((menu) => {
          const summary = menu.querySelector('summary');
          menu.removeAttribute('open');
          summary && summary.setAttribute('aria-expanded', false);
        });
        this.toggleOverlay(false);
      });
      this.overlay._lkpBound = true;
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    this.toggleOverlay(this.mainDetailsToggle.open);

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  toggleOverlay(isOpen) {
    if (!this.overlay) return;
    if (isOpen) {
      this.overlay.classList.add('is-visible');
      this.overlay.removeAttribute('hidden');
    } else {
      const anyOpen = document.querySelector('lkp-header-menu details[open]');
      if (!anyOpen) {
        this.overlay.classList.remove('is-visible');
        this.overlay.setAttribute('hidden', 'hidden');
      }
    }
  }
}

customElements.define('lkp-header-menu', HeaderMenu);
